import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { LegalFooterComponent } from '../shared/legal-footer/legal-footer.component';

@Component({
  selector: 'app-privacy-policy',
  standalone: true,
  imports: [CommonModule, RouterModule, LegalFooterComponent],
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['../shared/legal-pages.styles.scss']
})
export class PrivacyPolicyComponent {
  currentDate = new Date();

   constructor(
   private router: Router
  ) {}
  goBack() {
    this.router.navigate(['/']);
  }
}